import { render, staticRenderFns } from "./blocked.vue?vue&type=template&id=2d4a39c4&scoped=true"
import script from "./blocked.vue?vue&type=script&lang=js"
export * from "./blocked.vue?vue&type=script&lang=js"
import style0 from "./blocked.vue?vue&type=style&index=0&id=2d4a39c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a39c4",
  null
  
)

export default component.exports